import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import {
  WhatsappShareButton,
  EmailShareButton,
  WhatsappIcon,
  EmailIcon,
} from "react-share";

const ShareLinkView = ({ fileUrl, show, setShow, customerData }) => {
  const handleClose = () => setShow(false);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(fileUrl);
        alert("Link copied successfully!");
      } else {
        // Fallback for mobile browsers
        const textArea = document.createElement("textarea");
        textArea.value = fileUrl;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        document.execCommand("copy");
        document.body.removeChild(textArea);
      }
    } catch (err) {
      alert("Failed to copy link. Please copy manually.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Share</Modal.Title>
      </Modal.Header>

      <div className="d-flex gap-3 justify-content-center" style={{ marginTop: "3%" }}>
        <button
          onClick={() => {
            const phoneNumber = customerData?.phone || "";
            const message = encodeURIComponent(
              `Hello ${customerData?.name},\n\nWe hope you're doing well! \n\n` +
              `*${customerData?.business}* has shared an invoice with you. Please find the link below:\n\n` +
              `${fileUrl}\n\n` +
              `If you have any questions or need assistance, feel free to reach out to us.\n\n` +
              `Thank you for trusting *${customerData?.business}* on Billnama.`
            );

            const url = `https://wa.me/${phoneNumber}?text=${message}`;

            // Open the WhatsApp link in a new window/tab
            window.open(url, '_blank');
          }}
        >
          <WhatsappIcon size={40} round />
        </button>

        <button
          onClick={() => {
            const subject = `${customerData?.business} - Your Shared File from Billnama`;

            const body = `Dear ${customerData?.name},\n\n` +
              `We hope you're doing well! ${customerData?.business} has shared a invoice with you. Please find the link to access the file below:\n\n` +
              `${fileUrl}\n\n` +
              `If you have any questions or need assistance, feel free to reach out to us.\n\n` +
              `Thank you for trusting ${customerData?.business}. We truly appreciate your trust and support.\n\n` +
              `Best regards,\nThe BillNama Team`;

            const emailUrl = `mailto:${customerData?.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            window.location.href = emailUrl;

          }}
        >
          <EmailIcon size={40} round />
        </button>
      </div>

      <Modal.Body>
        <Form.Group className="mb-2">
          <Form.Label className="text-black">Copy & Share this link:</Form.Label>
          <div className="d-flex align-items-center gap-2">
            <Form.Control
              type="text"
              readOnly
              value={fileUrl}
              className="text-black bg-white"
            />
            <Button variant="info" onClick={handleCopy}>
              Copy
            </Button>
          </div>
        </Form.Group>
      </Modal.Body>
    </Modal>
  );
};

export default ShareLinkView;
